import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AngularFirestore } from 'angularfire2/firestore';
import { Documentos } from '../../models/documentos.model';


export 
  let VerDocumentoTemplate=
    `
   <mat-card fxLayout="column" fxLayoutAlign="center start">
     <!--mat-card-header>
      <b> {{title}} </b>
     </mat-card-header-->
     <br>
     <mat-card-content id="printable" [innerHtml]="text">
     <br>
     </mat-card-content>
     <mat-card-actions>
        <button mat-raised-button (click)="print('printable')">Imprimir</button>
        <button mat-raised-button (click)="doClick()">ok</button>
      </mat-card-actions>
   </mat-card>
  `;
  

@Component({
  selector: 'ver-documento',
  template: VerDocumentoTemplate ,
  styles: [``]
})
export class VerDocumentoComponent implements OnInit {
  @Input()
  title: string;
  @Input()
  text: string;
  constructor(
    private db: AngularFirestore,
    private params: ActivatedRoute,
    private router: Router,
    private location: Location,
  ) {

    var param = this.params.snapshot.params.nome;
    if (!param)
       param = this.params.snapshot.params.ident;
    if (param) {
      this.abrirDocumento(param);
    }

  }

  abrirDocumento(nome){
    let doc = new Documentos(this.db);
    doc.getDocumento(nome, d => {
      console.log(d);
      this.title = d[0].titulo;
      this.text = d[0].texto;
    })

  }
 

  ngOnInit(): void {
  }

  doClick() {
    console.log('doClick');
    //this.router.navigate(['/login']);
    this.location.back();
  }

  print(printSectionId: string){
    let popupWinindow
    let innerContents = document.getElementById(printSectionId).innerHTML;
    popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' +'<br>'+ innerContents + '</html>');
    popupWinindow.document.close();
}

}
